import { useState } from 'react';
import axios from 'axios';

export const useAdmin = () => {
  const [adminView, setAdminView] = useState(false);
  const [studentInfoAdminDict, setStudentInfoAdminDict] = useState({});
  const [studentSessionsDict, setStudentSessionsDict] = useState({})
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [expandedSessions, setExpandedSessions] = useState({});
  const [studentSearch, setStudentSearch] = useState("");
  const [completedModuleFilters, setCompletedModuleFilters] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isLoadingSessions, setIsLoadingSessions] = useState(false);
  const [sortConfig, setSortConfig] = useState({ 
    moduleId: null, 
    metric: null, 
    direction: 'asc' 
  });

  const fetchSessions = async (studentId) => {
    setIsLoadingSessions(true);
      
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/get_student_sessions`,
        { user_id: studentId }
      );

      setStudentSessionsDict(res.data.sessions);
      return { success: true };
    } catch (err) {
      console.error('Error getting student sessions:', err);
      return { success: false, error: err };
    } finally {
      setIsLoadingSessions(false);
    }
  };
  
  const toggleSession = (sessionId) => {
    setExpandedSessions((prev) => ({
      ...prev,
      [sessionId]: !prev[sessionId],
    }));
  };

  const handleSort = (moduleId, metric) => {
    setSortConfig((prev) => {
      if (prev.moduleId === moduleId && prev.metric === metric) {
        return {
          moduleId,
          metric,
          direction: prev.direction === 'asc' ? 'desc' : 'asc',
        };
      } else {
        return {
          moduleId,
          metric,
          direction: 'asc',
        };
      }
    });
  };

  const resetAdmin = () => {
    setAdminView(false);
    setSelectedStudent(null);
    setExpandedSessions({});
    setStudentSearch("");
    setCompletedModuleFilters([]);
  };

  return {
    // State
    adminView, setAdminView,
    studentInfoAdminDict, setStudentInfoAdminDict,
    studentSessionsDict, setStudentSessionsDict,
    selectedStudent, setSelectedStudent,
    expandedSessions,setExpandedSessions,
    studentSearch, setStudentSearch,
    completedModuleFilters, setCompletedModuleFilters,
    isLoadingSessions, setIsLoadingSessions,
    showDropdown, setShowDropdown,
    sortConfig,
    
    // Methods
    fetchSessions,
    toggleSession,
    handleSort,
    resetAdmin
  };
};
